<template>
  <section ref="root" class="dc-container">

    <!-- papel rasgado -->

    <!-- CONTENIDO -->
    <div class="dc-card">

      <!-- Título -->
      <h2 ref="title" class="dc-title">
        <span class="titulo-linea">Código de</span><br />
        <span class="script">Vestimenta</span>
      </h2>

      <!-- Badge -->
      <div ref="badge" class="dc-badge">
        FORMAL
      </div>

      <!-- Figura -->
      <img
        ref="figure"
        src="@/assets/trajes.png"
        alt="Código de vestimenta"
        class="dc-figure"
      />

    </div>


  </section>
</template>

<script>
import { ref, onMounted, nextTick, onUnmounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'DressCodeLuxuryExact',

  setup() {
    const root = ref(null)
    const title = ref(null)
    const badge = ref(null)
    const figure = ref(null)

    onMounted(async () => {
      await nextTick()

      if (!root.value) return

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root.value,
          start: 'top 85%',
          once: true
        }
      })

      /* ✨ TÍTULO */
      tl.from(
        title.value,
        {
          opacity: 0,
          y: -24,
          filter: 'blur(6px)',
          duration: 0.6,
          ease: 'power3.out'
        }
      )

      /* ✨ BADGE */
      .from(
        badge.value,
        {
          opacity: 0,
          y: -16,
          scale: 0.98,
          duration: 0.5,
          ease: 'back.out(1.6)'
        },
        '>-0.1'
      )

      /* ✨ FIGURA */
      .from(
        figure.value,
        {
          opacity: 0,
          scale: 0.9,
          duration: 0.55,
          ease: 'power2.out'
        },
        '>-0.05'
      )
    })

    onUnmounted(() => {
      ScrollTrigger.refresh()
    })

    return {
      root,
      title,
      badge,
      figure
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700&family=Great+Vibes&family=Playfair+Display:ital,wght@0,600;1,500&family=Poppins:wght@400;600&display=swap');

.dc-container {
  position: relative;
  max-width: 500px;
  margin: 0 auto;
  background-color: #f5f0e6;
  
  /* Efecto papel fino de invitación */
   padding: 34px 18px 42px;
  overflow: visible;
  text-align: center;
  
  margin-bottom: -40px;
}

/* Rasgados */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  background: #f5f0e6;
  z-index: 1;
  pointer-events: none;
}

.rasgado-top {
  top: 0;
  clip-path: polygon(0% 70%, 18% 55%, 38% 78%, 58% 52%, 78% 75%, 100% 60%, 100% 0%, 0% 0%);
}

.rasgado-bottom {
  bottom: 0;
  clip-path: polygon(0% 30%, 18% 45%, 38% 22%, 58% 48%, 78% 25%, 100% 40%, 100% 100%, 0% 100%);
}

.dc-card {
  position: relative;
  z-index: 2;
}

.dc-title {
  font-family: 'Cinzel', 'Playfair Display', serif;
  font-size: 28px;
  color: #4979a0;
  margin: 0 0 16px;
  line-height: 1.1;
  text-transform: uppercase;
  letter-spacing: 2px;
}

.dc-title .titulo-linea {
  font-weight: 700;
}

.dc-title .script {
  font-family: 'Great Vibes', cursive, serif;
  font-size: 42px;
  color: #cba56b;
  text-transform: none;
  font-weight: 500;
  letter-spacing: 1px;
}

.dc-badge {
  display: inline-block;
  background: #cba56b;
  color: #ffffff;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 0.18em;
  padding: 8px 22px;
  border-radius: 20px;
  box-shadow: 0 4px 10px rgba(73, 121, 160, 0.15);
  margin: 4px 0 16px;
  text-transform: uppercase;
}

.dc-figure {
  width: 200px;
  margin: 10px auto 12px;
  display: block;
  filter: brightness(0) saturate(100%) invert(48%) sepia(21%) saturate(986%) hue-rotate(167deg) brightness(92%) contrast(87%);
}
</style>